import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ControlContainer, FormGroup, FormGroupDirective } from '@angular/forms'
import { Venue } from '../domain/Venue'

@Component({
    selector: 'app-accessibility-form',
    templateUrl: './accessibility-form.component.html',
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective,
        },
    ],
})
export class AccessibilityFormComponent implements OnInit {

    @Input() venue: Venue | null = null
    @Input() isLoading!: boolean
    @Output() restrictionsSelected = new EventEmitter<void>()
    form!: FormGroup
    showWheelchairAccessibleQuestion!: boolean
    showDogFriendlyQuestion!: boolean
    showPramAccessibleQuestion!: boolean
    showHighchairFriendlyQuestion!: boolean

    constructor(
        private rootFormGroup: FormGroupDirective
    ) { }

    ngOnInit() {
        this.form = this.rootFormGroup.form
        this.showWheelchairAccessibleQuestion = this.venue?.wheelchairAccessibleQuestionEnabled ?? false
        this.showDogFriendlyQuestion = this.venue?.dogFriendlyQuestionEnabled ?? false
        this.showPramAccessibleQuestion = this.venue?.pramAccessibleQuestionEnabled ?? false
        this.showHighchairFriendlyQuestion = this.venue?.highchairFriendlyQuestionEnabled ?? false
    }

    next() {
        const wheelchairAccess = this.form.get('requiresWheelchairAccess')
        if (wheelchairAccess?.value === null) {
            wheelchairAccess.setValue(false)
        }
        const dogFriendly = this.form.get('requiresDogFriendly')
        if (dogFriendly?.value === null) {
            dogFriendly.setValue(false)
        }
        const pramAccessible = this.form.get('requiresPramAccessible')
        if (pramAccessible?.value === null) {
            pramAccessible.setValue(false)
        }
        const highchairFriendly = this.form.get('requiresHighchairFriendly')
        if (highchairFriendly?.value === null) {
            highchairFriendly.setValue(false)
        }
        this.restrictionsSelected.emit()
    }
}
